import { useRouter } from './useRouter';

/**
 * Returns a source if one is provided in the current url.
 * @returns string - source
 */
export const useRouteSource = (): string | undefined => {
  const router = useRouter();

  if (!router) return undefined;

  const { source } = router.query;

  if (!source) return undefined;
  if (typeof source === 'string') return source;
  if (Array.isArray(source)) return source[0];

  return undefined;
};
